import React from 'react';
import { useEffect, useState } from 'react';

export const LoadingDots: React.FC<{ speed?: number }> = ({ speed = 400 }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            setIndex((prev) => (prev + 1) % 4);
        }, speed);
        return () => clearInterval(id);
    }, [speed]);

    const dotsMap = ['.', '..', '...'];
    const dots = dotsMap[index];

    return <span style={{ display: 'inline-block', minWidth: '5ch' }}>{dots}</span>;
};
